import React from 'react';

export const FranchiseVertical = ({hed, subHed, verticalImg, verticalImgMobile, caption}) => {
  return (
    <div className="franchise_vertical_container">
      <div className="main_content">
        <div className="text_column">
          <h1> {hed}</h1>
          <h2> {subHed} </h2>
        </div>
        <div className="image_column">
          <picture>
            <source
              media="(max-width: 600px)"
              srcSet={verticalImgMobile}
            />
            <img src={verticalImg} alt="" />
          </picture>
          <p className="caption"> {caption}</p>
        </div>
      </div>
    </div>
  );
}